const assetsUrl = () => {
    return process.env.VUE_APP_ASSETS;
}
export const fitnessNetworksUtils = {
    keys: {
        strava: process.env.VUE_APP_STRAVA_CLIENT,
        trainingpeaks: process.env.VUE_APP_TRAINING_PEAK_CLIENT,
        intervals: process.env.VUE_APP_INTERVALS_IO_CLIENT,
        analogx: process.env.VUE_APP_ANALOGX_CLIENT,
        whoop: process.env.VUE_APP_WHOOP_CLIENT,
        trainerday: process.env.VUE_APP_TRAINERDAY_CLIENT,
    },
    terms: {
        analogx: process.env.VUE_APP_ANALOGX_CLIENT_TERMS,
    },
    networks: [
        {
            name: "strava",
            logo: `${assetsUrl()}/images/strava.jpg`,
        },
        {
            name: "trainingpeaks",
            logo: `${assetsUrl()}/images/training-peaks.png`,
        },
        {
            name: "intervals",
            logo: "/assets/images/intervals-logo.png",
        },
        {
            name: "analogx",
            logo: "/assets/images/analog-logo.png",
        },
        {
            name: "xert",
            logo: "/assets/images/xert-logo.png",
        },
        {
            name: "whoop",
            logo: "/assets/images/whoop.png",
        },
        {
            name: "trainerday",
            logo: "/assets/images/trainerday.jpeg",
        },
    ],
};
